import type { UseFormRegister, FieldErrors } from 'react-hook-form';
import type { FormSubmissionInput } from '@qdf/shared';
import { US_STATES } from '@qdf/shared';
import { Input } from '../ui/Input.js';
import { Select } from '../ui/Select.js';

interface CompanyInfoSectionProps {
  register: UseFormRegister<FormSubmissionInput>;
  errors: FieldErrors<FormSubmissionInput>;
}

const stateOptions = US_STATES.map((s) => ({ value: s, label: s }));

export function CompanyInfoSection({ register, errors }: CompanyInfoSectionProps) {
  return (
    <>
      {/* Applicant & Entity */}
      <fieldset>
        <legend className="text-lg font-semibold text-gray-900 mb-4 pb-2 border-b border-gray-200">
          Applicant Information
        </legend>

        <div className="grid grid-cols-1 gap-4">
          <Input
            label="Full Name"
            required
            {...register('fullName')}
            error={errors.fullName?.message}
          />
          <Input
            label="LLC Entity Name"
            required
            {...register('entityName')}
            error={errors.entityName?.message}
          />
          <Input
            label="DBA (Doing Business As)"
            {...register('dba')}
            error={errors.dba?.message}
          />
        </div>
      </fieldset>

      {/* Contact */}
      <fieldset>
        <legend className="text-lg font-semibold text-gray-900 mb-4 pb-2 border-b border-gray-200">
          Contact Information
        </legend>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <Input
            label="Email"
            type="email"
            required
            {...register('email')}
            error={errors.email?.message}
          />
          <Input
            label="Phone"
            type="tel"
            required
            {...register('phone')}
            error={errors.phone?.message}
          />
        </div>
      </fieldset>

      {/* Mailing Address */}
      <fieldset>
        <legend className="text-lg font-semibold text-gray-900 mb-4 pb-2 border-b border-gray-200">
          Mailing Address
        </legend>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <Input
            label="Address Line 1"
            required
            {...register('mailingAddress1')}
            error={errors.mailingAddress1?.message}
            className="sm:col-span-2"
          />
          <Input
            label="Address Line 2"
            {...register('mailingAddress2')}
            error={errors.mailingAddress2?.message}
            className="sm:col-span-2"
          />
          <Input
            label="City"
            required
            {...register('mailingCity')}
            error={errors.mailingCity?.message}
          />
          <div className="grid grid-cols-2 gap-4">
            <Select
              label="State"
              required
              options={stateOptions}
              {...register('mailingState')}
              error={errors.mailingState?.message}
            />
            <Input
              label="ZIP"
              required
              {...register('mailingZip')}
              error={errors.mailingZip?.message}
            />
          </div>
        </div>
      </fieldset>
    </>
  );
}
